"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorAction = void 0;
var createErrorAction = function (_a) {
    var error = _a.error, description = _a.description;
    if (!error) {
        return {
            type: 'SET_ERROR_ACTION',
            description: description,
            values: {
                description: description,
                type: 'unexpected',
                code: 'n/a',
                message: 'n/a',
            },
        };
    }
    if (error.code) {
        return {
            type: 'SET_ERROR_ACTION',
            description: description,
            values: {
                description: description,
                type: 'firebase',
                code: error.code,
                message: error.message,
            },
        };
    }
    return {
        type: 'SET_ERROR_ACTION',
        description: description,
        values: {
            description: description,
            type: 'other',
            code: error.code,
            message: error.message || error.description || JSON.stringify(error),
        },
    };
};
exports.createErrorAction = createErrorAction;
